import { useEffect } from "react";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Topics from "@/components/site/Topics";
import Footer from "@/components/site/Footer";

export default function Home() {
  // Smooth-scroll if URL has hash
  useEffect(() => {
    if (window.location.hash) {
      const id = window.location.hash.slice(1);
      setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
      }, 200);
    }
  }, []);

  return (
    <div className="min-h-screen" data-testid="home-page">
      <Navbar />
      <main>
        <Hero />
        <Topics />
      </main>
      <Footer />
    </div>
  );
}
